export const updateUserWithConnection = /* GraphQL */ `
  mutation UpdateUser(
    $input: UpdateUserInput!
    $condition: ModelUserConditionInput
  ) {
    updateUser(input: $input, condition: $condition) {
      loginName
      tenant
      landscape
      displaysFavoritePanel
      isAdmin
      roleId
      language
      name
      affiliation
      csrSchema
      cwsSchema
      cjkSchema
      ctmSchema
      event {
        html
        loginName
        tenant
        landscape
        createdAt
        updatedAt
      }
      notice {
        html
        loginName
        tenant
        landscape
        createdAt
        updatedAt
      }
      menus {
        items {
          menuId
          parentMenuId
          url
          isCategory
          product
          schemaId
          loginName
          tenant
          landscape
          tenantLandscapeLoginName
          accessedTimeStamp
          sort
          canUseFromExtra
          menuIconFont
          createdAt
          updatedAt
        }
        nextToken
      }
      productMenus {
        items {
          loginName
          tenant
          landscape
          menuId
          isHome
          stateKey
          createdAt
          updatedAt
        }
        nextToken
      }
      flags {
        items {
          flag
          loginName
          tenant
          landscape
          createdAt
          updatedAt
        }
        nextToken
      }
      favorites {
        items {
          sort
          menuId
          loginName
          tenant
          landscape
          createdAt
          updatedAt
        }
        nextToken
      }
      notifications {
        items {
          loginName
          tenant
          landscape
          tenantLandscapeLoginName
          product
          notificationId
          content
          iconType
          onClickAction
          displayStartDate
          displayEndDate
          isRead
          isFinished
          createdAt
          updatedAt
        }
        nextToken
      }
      announcements {
        items {
          announcementId
          loginName
          tenant
          landscape
          tenantLandscapeLoginName
          displayStartDate
          displayEndDate
          isProcessed
          isRead
          isShow
          createdAt
          updatedAt
        }
        nextToken
      }
      scheduledEventMetadatasByCreatedBy {
        items {
          id
          tenant
          landscape
          tenantLandscape
          title
          description
          jobId
          repeatType
          rruleSet
          holidayExecutionType
          useCustomHoliday
          customHolidayLabels
          eventTriggerType
          createdBy
          updatedBy
          editedAt
          expirationDate
          createdAt
          updatedAt
        }
        nextToken
      }
      scheduledEventMetadatasByUpdatedBy {
        items {
          id
          tenant
          landscape
          tenantLandscape
          title
          description
          jobId
          repeatType
          rruleSet
          holidayExecutionType
          useCustomHoliday
          customHolidayLabels
          eventTriggerType
          createdBy
          updatedBy
          editedAt
          expirationDate
          createdAt
          updatedAt
        }
        nextToken
      }
      scheduledEventHistoriesByExecutedBy {
        items {
          id
          tenant
          landscape
          tenantLandscape
          title
          description
          scheduledEventMetadataId
          eventStartDateTime
          jobId
          jobExecutionStatus
          executedBy
          executionArn
          createdAt
          updatedAt
        }
        nextToken
      }
      scheduledHolidayMetadatasByCreatedBy {
        items {
          id
          tenant
          landscape
          tenantLandscape
          title
          description
          repeatType
          rruleSet
          labels
          createdBy
          updatedBy
          createdAt
          updatedAt
        }
        nextToken
      }
      scheduledHolidayMetadatasByUpdatedBy {
        items {
          id
          tenant
          landscape
          tenantLandscape
          title
          description
          repeatType
          rruleSet
          labels
          createdBy
          updatedBy
          createdAt
          updatedAt
        }
        nextToken
      }
      productMenuNames {
        items {
          language
          name
          menuId
          loginName
          tenant
          landscape
          createdAt
          updatedAt
        }
        nextToken
      }
      countTables {
        items {
          loginName
          tenant
          landscape
          tableName
          totalCount
          isUnRead
          isExpired
          createdAt
          updatedAt
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
